export const INVENTORY_SETTING = 'warehouse_app.has_inventory'

export const useTenantSettingsStore = defineStore('tenantSettings', () => {
  const settings = ref<Record<string, any>>({})
  const loaded = ref(false)

  let pending: Promise<void> | null = null

  async function load() {
    const response = await useApi('tenant/settings', 'GET')
    settings.value = (response?.data ?? {}) as Record<string, any>
    loaded.value = true
  }

  async function fetchSettings(force = false) {
    if (loaded.value && !force) return
    if (force) pending = null
    if (!pending) {
      pending = load().finally(() => {
        pending = null
      })
    }
    await pending
  }

  function isEnabled(name: string) {
    const value = settings.value?.[name]
    return value === '1' || value === 1 || value === true || value === 'true'
  }

  const hasInventory = computed(() => isEnabled(INVENTORY_SETTING))

  return { settings, loaded, fetchSettings, isEnabled, hasInventory }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTenantSettingsStore, import.meta.hot))
}
